import { Inject, Injectable } from '@angular/core';
import { RESTANGULAR_SETTINGS } from '@app/common/services/restangular-settings.service';
import { APPLICATIONS } from '@app/common/services/config.service';
import { AuthService } from "@app/common/services/auth.service";
import { LayersConfigService} from "@app/map/services/layers-config.service";

@Injectable({
  providedIn: 'root'
})
export class NewMapConfigService {
  private layersConfigs: any;

  constructor(
    @Inject(APPLICATIONS) private APPLICATIONS,
    @Inject(RESTANGULAR_SETTINGS) private restangularUsers,
    private authService: AuthService,
    private layersConfigService: LayersConfigService,
  ) {
    this.layersConfigs = {};
  }

  setModuleLayers(module, projectKey, layers) {
    this.layersConfigs[module] = this.layersConfigs[module] || {};
    this.layersConfigs[module][projectKey] = layers;
    return this.layersConfigs[module][projectKey];
  }

  getLayerById(layerId, layerGroups) {
    const lookIn = (layers) => {
      let layer = layers.find((l) => l.id === layerId);
      if (layer) {
        return layer;
      }
      for (const layer2 of layers) {
        if (layer2.layers) {
          layer = lookIn(layer2.layers);
          if (layer) {
            return layer;
          }
        }
      }
      return null;
    };

    for (const group of layerGroups) {
       const layer = lookIn(group.layers);
       if (layer) {
         return layer;
       }
    }
    return null;
  }

  loadModuleLayers(module, projectKey) {
    switch (module) {
      case this.APPLICATIONS.sy.name:
        return this.restangularUsers.one(`application/${this.APPLICATIONS.sy.name}/project/${projectKey}/map`).get().toPromise().then((data) => {
          const result = {
            type: 'node',
            selector: 'hidden',
            layers: data
          };
          this.setModuleLayers(module, projectKey, result);
          return Promise.resolve(result);
        });
      case this.APPLICATIONS.di.name:
        // TODO unimplemented
        return Promise.resolve(null);
      default:
    }
  }

  loadPriorityLayers() {
    const project = this.authService.getActualProject();
    if (project.occupationsPriority && project.occupationsPriority.enabled) {
      const layers = [...project.occupationsPriority.categories]
        .map((c, i) => {
          const { r, g, b, a} = c.color;
          return ({
            id: `occupation_priority_${i}`,
            style: {
              stroke: { r, g, b, a: c.a },
              fill: { r, g, b, a: 0.5 }
            },
            type: 'wfs',
            title: c.name,
            description: '',
            selector: 'switch',
            visible: c.visible,
            opacity: 1,
            url: this.layersConfigService.getSYwfsLayersUrl(),
            chunked: true,
            parent: contentLayer,
            geometryColumn: 'geom',
            wfs: {
              feature_count: 10,
              count: 1000,
              typeNames: this.layersConfigService.getSYlayerPrefix() + 'occupation',
              sortBy: 'id',
            },
            filter: {
              type: 'And',
              arg1: {
                type: "PropertyIsEqualTo",
                propertyName: "priority_index",
                literal: i
              },
              arg2: {
                type: 'PropertyIsNull',
                propertyName: 'end_date'
              }
            },
            featureSummaryTemplate: this.layersConfigService.getOccupationTemplate(),
            geojson: this.layersConfigService.getGeoJsonSettings(`rgb(${r}, ${g}, ${b})`),
          })})
        .reverse();

      const contentLayer: any = {
        id: 'occupationsPriorities',
        type: 'node',
        title: 'Priority trvalých záborů',
        selector: 'group',
        visible: project.occupationsPriority.enabled,
        layers,
      };

      return contentLayer;
    }
  }

  getLayersConfig(module, projectKey, fresh = false) {
    const loadedAlready = this.layersConfigs[module] && this.layersConfigs[module][projectKey];

    if (fresh || !loadedAlready) {
      return this.loadModuleLayers(module, projectKey).then((response) => {
        return response;
      });
    } else {
      return Promise.resolve(this.layersConfigs[module][projectKey]);
    }
  }
}

